module.exports = __webpack_public_path__ + "static/media/image4.879ee2b4.svg";